import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from '../Loader'
import SamplesGuide from './Guides/SamplesGuide'
import classNames from 'classnames'
import { formatMessage, injectIntl } from 'react-intl'
import {
  uploadImage,
  updateImageData,
  saveCurrentImage,
  resetImageDataUrl,
} from '../../actions/ImageUpload'
import { changeProfilePicInitialEditState } from '../../actions/Edit'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import ImageEditor from './HelperComponents/ImageEditor'
import {
  feedbackMap,
  colorMap,
  symbolMap,
} from '../Constants/ProfilePictureFeedback'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import { fetchCustomisation } from '../../services/helpers'

const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

class ProfilePicture extends Component {
  constructor(props) {
    super(props)
    this.notDetectedAnything = false
    this.state = {
      showInfoScreen: false,
      activeInfoScreen: '',
      clicked: false,
      editMade: false,
      modalState: 0,
      cropperOpen: false,
      img: null,
      croppedImg: '',
    }
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.changeClicked = this.changeClicked.bind(this)
    this.hasSampleScrolled = false
    this.handleSampleScroll = this.handleSampleScroll.bind(this)
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
    this.sendTrackingDataDebounceSample = _.debounce(
      sendTrackingData,
      3000,
      true
    )
    this.handleFileChange = this.handleFileChange.bind(this)
    this.handleRequestHide = this.handleRequestHide.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleEditMade = this.handleEditMade.bind(this)
    this.resetImage = this.resetImage.bind(this)
    this.renderImageEditor = this.renderImageEditor.bind(this)
    this.handleFile = this.handleFile.bind(this)
    this.saveUploadedImage = this.saveUploadedImage.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
    this.sendTrackingDataDebounceClick = _.debounce(
      sendTrackingData,
      1000,
      true
    )
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 2000, true)
    this.updateState = this.updateState.bind(this)
    this.dataURI = null
    this.imageUrl = null
  }

  UNSAFE_componentWillMount() {
    const { updateImageData } = this.props
    updateImageData({
      updateKeys: [['edit_picture_mounted']],
      data: { edit_picture_mounted: true },
    })
  }

  componentDidMount() {
    const { sectionWiseTextEditable, imageData } = this.props
    this.setState({ img: imageData.dataUri })
    window.addEventListener('scroll', this.handleSampleScroll)
    let url = this.fetchImageUrl(sectionWiseTextEditable[0] && sectionWiseTextEditable[0]['picture_url'])
    this.replaceImageWithAvatarIfNotPresent('edit-profile-img')
    this.setState({
      modalState: this.props.initialState,
    })
    window.addEventListener('resize', this.handleScreenResize)
  }

  componentWillUnmount() {
    const { updateImageData, resetImageDataUrl, sectionWiseText } = this.props
    window.removeEventListener('scroll', this.handleSampleScroll)
    updateImageData({
      updateKeys: [['edit_picture_mounted']],
      data: { edit_picture_mounted: false },
    })
    resetImageDataUrl(this.fetchImageUrl(sectionWiseText['imageUrl']))
    window.removeEventListener('resize', this.handleScreenResize)
  }

  UNSAFE_componentWillUpdate() {
    this.replaceImageWithAvatarIfNotPresent('edit-profile-img')
    this.notDetectedAnything = false
  }

  componentDidUpdate(prevProps) {
    const {
      imageData,
      sectionWiseTextEditable,
      sectionWiseText,
      toggleKeyboardFunctionality,
      feedback,
    } = this.props
    const { clicked } = this.state

    if (prevProps.imageData.dataUri !== imageData.dataUri) {
      this.setState({ img: imageData.dataUri })
    }
    if (imageData.uploaded_image == true) {
      const { updateImageData } = this.props
      updateImageData({
        updateKeys: [['uploaded_image']],
        data: { uploaded_image: false },
      })
      this.props.handleOnChangePicture(this.props.currentIndex, imageData)
    }
    if (
      feedback.section_score[0].score !==
      prevProps.feedback.section_score[0].score
    ) {
      const { updateImageData } = this.props
      updateImageData({
        updateKeys: [['update_store']],
        data: { update_store: true },
      })
    }
    if (clicked) {
      this.changeClicked(false)
      $(this.formPhoto).trigger('click')
    }
    toggleKeyboardFunctionality(this.state.modalState !== 1)
  }

  handleFileChange(dataURI) {
    this.setState({
      img: dataURI,
      cropperOpen: true,
      modalState: 1,
    })
    this.saveUploadedImage(dataURI)
  }

  handleEditMade(isEdit) {
    this.setState({
      editMade: isEdit,
    })
  }

  saveUploadedImage(dataURI) {
    const { saveCurrentImage, intl } = this.props
    const blob = this.dataURItoBlob(dataURI)
    const formData = new FormData()
    formData.append('original_picture', blob)
    saveCurrentImage(formData, intl)
    this.dataURI = dataURI
  }

  dataURItoBlob(dataURI) {
    if (_.isEmpty(dataURI)) {
      return null
    }
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1])
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length)

    // create a view into the buffer
    var ia = new Uint8Array(ab)

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString })
    return blob
  }

  handleRequestHide() {
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      'cropped_img_close_btn'
    )
    this.setState({
      cropperOpen: false,
    })
    $('body').removeClass('modal-open')
  }

  handleClickEdit(e) {
    e.preventDefault()
    const { uploading } = this.props
    if (!uploading) {
      this.formPhoto.value = ''
      $(this.formPhoto).trigger('click')
    }
    this.sendTrackingDataDebounceClick(
      'event',
      'aspire_edit_screen',
      'click',
      'click_to_change_btn'
    )
  }


  changeClicked(clicked) {
    this.setState({ clicked: clicked })
  }

  changePicture() {
    this.changeClicked(true)
  }


  openEditModal() {
    this.setState({
      croppedImg: this.imageUrl,
      cropperOpen: true,
      modalState: 1,
    })
  }



  replaceImageWithAvatarIfNotPresent(id) {
    $('#' + id).on('error', function () {
      $(this).attr(
        'src',
        `${process.env.APP_BASE_URL}dist/images/profile-avatar.png`
      )
    })
  }

  resetImage() {
    this.setState({
      img: null,
    })
  }


  handleFile(e, file = null) {
    var reader = new FileReader()
    if (_.isNull(file)) {
      file = e.target.files[0]
    }
    if (!file) {
      return
    }
    let pictureName = null,
      pictureSize = null,
      pictureType = null

    if (file) {
      pictureName = file.name
      pictureSize = file.size
      pictureType = file.type
    }
    const notifyErrorOptions = { timeout: 10000 }
    if (pictureName) {
    }
    if (pictureSize) {
      if (pictureSize > 8388608) {
        notification(
          this.props.intl.formatMessage({
            id: 'aspire.profilePicture.uploadFailedFileSize',
            defaultMessage: 'Failed to upload file. File size exceeds 8MB.',
          }),
          'error'
        )
        this.sendTrackingDataDebounce(
          'process',
          'aspire_edit_screen',
          'notify_error',
          'upload_picture_exceeds_size'
        )
        this.formPhoto.value = ''
        return
      }
    }

    const fileTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const invalidFileMessage = this.props.intl.formatMessage({
      id: 'aspire.profilePicture.invalidFileType',
      defaultMessage: 'The file type is not supported. Please choose an image.',
    })
    if (fileTypes.indexOf(pictureType) === -1) {
      notification(invalidFileMessage, 'error')
      this.sendTrackingDataDebounce(
        'process',
        'aspire_edit_screen',
        'notify_error',
        'upload_failed_not_image_type'
      )
      this.formPhoto.value = ''
      return
    }

    reader.onload = function (img) {
      this.handleFileChange(img.target.result)
    }.bind(this)
    reader.readAsDataURL(file)
  }

  renderImageEditor(isPictureUploaded, initialFeedback) {
    const {
      processingStatus,
      imageData,
      hideEditModal,
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
      handleSaveChanges,
      savingChanges,
      focusDisable,
      hideSmileAndFBRatio,
      feedback,
    } = this.props
    let uploading = imageData.uploading_image
    let imageToEdit = this.state.img
    let uploadBtnText = this.props.intl.formatMessage({
      id: 'aspire.profilePicture.editProfilePicture',
      defaultMessage: 'Edit Profile Picture',
    })
    let img = imageToEdit
    if (_.isEmpty(imageToEdit)) {
      img = this.dataURI
    }
    return (
      <>
        <ImageEditor
          handleClick={this.handleClickEdit}
          img={img}
          isOpen={this.state.modalState === 1}
          onRequestHide={this.handleRequestHide}
          handleFileChange={this.handleFileChange}
          feedback={feedback}
          initialFeedback={initialFeedback}
          uploading={uploading}
          hideEditModal={hideEditModal}
          currentIndex={currentIndex}
          sectionWiseTextEditable={sectionWiseTextEditable}
          sectionWiseTextStatic={sectionWiseTextStatic}
          handleSaveChanges={handleSaveChanges}
          savingChanges={savingChanges}
          focusDisable={focusDisable}
          hideSmileAndFBRatio={hideSmileAndFBRatio}
          initialState={this.props.initialState}
          updateState={this.updateState}
          handleEditMade={this.handleEditMade}
          editMade={this.state.editMade}
          resetImage={this.resetImage}
        />
      </>
    )
  }

  updateState(state) {
    if (state <= 1) {
      this.setState({
        modalState: state,
      })
    } else {
      this.setState({
        modalState: 1,
      })
    }
  }

  fetchImageUrl(url) {
    if (_.isEmpty(url)) {
      return `${process.env.APP_BASE_URL}dist/images/profile-avatar.png`
    }

    return url
  }

  renderFeedback(parameter, title, feedback, isFirst, tabIndex) {
    const { intl } = this.props
    if (_.isUndefined(feedback['color_feedback'])) {
      this.notDetectedAnything = true
      return [
        <div className="col-sm-6 profile-picture-col">
          <span
            className={
              'profile-picture-status-icon empty-icon ' + colorMap['gray']
            }>
            {' '}
          </span>
          <span
            tabIndex={tabIndex}
            aria-label={this.props.intl.formatMessage({
              id: 'aspire.profilePicture.unableToDetectTitle',
              defaultMessage: '{title} not detected',
            },{title})}
            className={classNames('feedback-tile-text', {
              'width-85': feedbackMap(intl)[parameter]['gray'].length > 85,
            })}>
            {title}
          </span>
        </div>,
        'not_detected',
      ]
    } else {
      return [
        <div className="as-picture-feedback-tile">
          <div className="as-picture-parameter-status-icon">
            <img
              alt=""
              src={`${process.env.APP_BASE_URL}dist/images/${
                iconMap[feedback['color_feedback']]
              }`}
              className="as-picture-feedback-parameter-icon"
              height="20"
              width="20"
            />
          </div>
          <div className="as-picture-feedback-parameter-text">{title}</div>
        </div>,
        'detected',
      ]
    }
  }

  renderInitialFeedback(parameter, title, feedback, isFirst, tabIndex) {
    const { imageData, intl } = this.props
    if (_.isUndefined(feedback['color_feedback'])) {
      this.notDetectedAnything = true
      return [
        <div className="col-sm-6 profile-picture-col">
          <span
            className={
              'profile-picture-status-icon empty-icon ' + colorMap['gray']
            }>
            {' '}
          </span>
          <span
            tabIndex={tabIndex}
            aria-label={this.props.intl.formatMessage({
              id: 'aspire.profilePicture.unableToDetectTitle',
              defaultMessage: '{title} not detected',
            }, {title})}
            className={classNames('feedback-tile-text', {
              'width-85': feedbackMap(intl)[parameter]['gray'].length > 85,
            })}>
            {title}
          </span>
        </div>,
        'not_detected',
        'grey',
      ]
    } else {
      return [
        <div
          className={`as-picture-feedback-tile edit-picture-feedback-tile edit-picture-feedback-tile-${feedback['color_feedback']}`}>
          <div className="profile-picture-status-info">
            <div className="feedback-parameter-status-icon">
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${
                  iconMap[feedback['color_feedback']]
                }`}
                className="feedback-parameter-icon"
                width="20"
                height="20"
              />
            </div>
            {title}
          </div>
          {feedback['color_feedback'] !== 'green' && (
            <div className="profile-picture-status-desc">
              {feedbackMap(intl)[parameter][feedback['color_feedback']]}
            </div>
          )}
        </div>,
        'detected',
        feedback['color_feedback'],
      ]
    }
  }

  handleUndoClick() {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Profile Picture',
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.props.handleUndoData('profile_picture', this.props.currentIndex)
  }

  handleSampleScroll() {
    const { sectionName, currentIndex } = this.props
    if (!this.hasSampleScrolled) {
      this.hasSampleScrolled = true
      let jsonObjectForTracking = {
        eventLabel: 'sample_scrolled',
        currentSection: 'Profile Picture',
        currentIndex: currentIndex,
      }
      this.sendTrackingDataDebounceSample(
        'event',
        'aspire_edit_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
    }
  }

  handleScreenResize() {
    let modalElement = document.getElementsByClassName(
      'profile-picture-edit-modal'
    )

    if (modalElement.length > 0) {
      modalElement[0].style.paddingLeft = '0px'
    }
  }
  render() {
    const {
      fetchId,
      hideEditModal,
      sectionWiseText,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      feedback,
      handleSaveChanges,
      currentIndex,
      handleUndoData,
      imageData,
      uploadImage,
      processingStatus,
      savingChanges,
      toggleKeyboardFunctionality,
      focusDisable,
      hideSmileAndFBRatio,
      user,
      initialState,
      showLogModal,
      intl
    } = this.props

    const { modalState } = this.state
    const { community } = user
    let params = [
      ['face_frame_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
      ['face_body_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceBodyRatio', defaultMessage: 'Face/Body Ratio' })],
      ['background', intl.formatMessage({ id: 'aspire.samplesGuide.backgroundDetection', defaultMessage: 'Background Illumination' })],
      ['foreground', intl.formatMessage({ id: 'aspire.samplesGuide.foregroundDetection', defaultMessage: 'Foreground Illumination' })],
      ['pupil', intl.formatMessage({ id: 'aspire.samplesGuide.eyeContact', defaultMessage: 'Eye Contact' })],
      ['smile', intl.formatMessage({ id: 'aspire.samplesGuide.smileDetection', defaultMessage: 'Smile Detection' })],
    ]
    if (community === 'ensign') {
      params = [
        ['face_frame_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
        ['face_body_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceBodyRatio', defaultMessage: 'Face/Body Ratio' })],
        ['pupil', intl.formatMessage({ id: 'aspire.samplesGuide.eyeContact', defaultMessage: 'Eye Contact' })],
        ['foreground', intl.formatMessage({ id: 'aspire.samplesGuide.foregroundDetection', defaultMessage: 'Foreground Illumination' })],
        ['smile', intl.formatMessage({ id: 'aspire.samplesGuide.smileDetection', defaultMessage: 'Smile Detection' })],
      ]
    }
    if (hideSmileAndFBRatio) {
      params = [
        ['face_frame_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
        ['foreground', intl.formatMessage({ id: 'aspire.samplesGuide.foregroundDetection', defaultMessage: 'Foreground Illumination' })],
        ['background', intl.formatMessage({ id: 'aspire.samplesGuide.backgroundDetection', defaultMessage: 'Background Illumination' })],
        ['pupil', intl.formatMessage({ id: 'aspire.samplesGuide.eyeContact', defaultMessage: 'Eye Contact' })],
      ]
      if (community === 'ensign') {
        params = [
          ['face_frame_ratio', intl.formatMessage({ id: 'aspire.samplesGuide.faceFrameRatio', defaultMessage: 'Face/Frame Ratio' })],
          ['foreground', intl.formatMessage({ id: 'aspire.samplesGuide.foregroundDetection', defaultMessage: 'Foreground Illumination' })],
          ['pupil', intl.formatMessage({ id: 'aspire.samplesGuide.eyeContact', defaultMessage: 'Eye Contact' })],
        ]
      }
    }
    let output = { detected: [], not_detected: [] }
    let outputInitial = { detected: [], not_detected: [] }
    let outputInitialOrder = {
      green: [],
      yellow: [],
      red: [],
    }
    if (sectionWiseTextEditable[0] && !_.isEmpty(sectionWiseTextEditable[0]['picture_url'])) {
      for (let i = 0; i < params.length; i++) {
        let isFirst = false
        if (i % 2 == 0) {
          isFirst = true
        }

        let t = this.renderFeedback(
          params[i][0],
          params[i][1],
          sectionWiseTextEditable[0][params[i][0]],
          isFirst,
          0
        )
        let initFeedback = this.renderInitialFeedback(
          params[i][0],
          params[i][1],
          sectionWiseTextEditable[0][params[i][0]],
          isFirst,
          0
        )
        if (!_.isNull(t)) {
          output[t[1]].push(t[0])
        }
        if (!_.isNull(initFeedback) && initFeedback[1] !== 'detected') {
          outputInitial[initFeedback[1]].push(initFeedback[0])
        }
        if (!_.isNull(initFeedback) && initFeedback[1] === 'detected') {
          outputInitialOrder[initFeedback[2]].push(initFeedback[0])
        }
      }
    }
    outputInitial['detected'] = outputInitial['detected'].concat(
      outputInitialOrder['red']
    )
    outputInitial['detected'] = outputInitial['detected'].concat(
      outputInitialOrder['yellow']
    )
    outputInitial['detected'] = outputInitial['detected'].concat(
      outputInitialOrder['green']
    )
    var obj = outputInitial
    var result = Object.keys(obj).map(function (key) {
      return [key, obj[key]]
    })
    let initialFeedback = result
    let pictureNotUploaded = []
    let isPictureUploaded = true

    if (!sectionWiseTextEditable[0] || _.isEmpty(sectionWiseTextEditable[0]['picture_url'])) {
      _.map(params, (value, key) => {
        pictureNotUploaded.push(
          <div className="as-picture-feedback-tile">
            <div className="as-picture-parameter-status-icon">
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${iconMap['red']}`}
                className="as-picture-feedback-parameter-icon"
                height="20"
                width="20"
              />
            </div>
            <div className="as-picture-feedback-parameter-text">{value[1]}</div>
          </div>
        )
      })
      isPictureUploaded = false
    }

    let imageUrl = this.fetchImageUrl(sectionWiseText['imageUrl'])
    if (imageData.refresh_url || this.state.editMade) {
      imageUrl = _.isNull(imageData['url'])
        ? this.fetchImageUrl('')
        : imageData['url']
    }
    this.imageUrl = imageUrl
    let uploading = imageData.uploading_image
    this.dataURI = imageData.dataUri
    let uploadBtnText = this.props.intl.formatMessage({
      id: 'aspire.profilePicture.editProfilePicture',
      defaultMessage: 'Edit Profile Picture',
    })
    if (!isPictureUploaded) {
      uploadBtnText = this.props.intl.formatMessage({
        id: 'aspire.profilePicture.upload',
        defaultMessage: 'Upload',
      })
      if (!_.isEmpty(this.dataURI)) {
        uploadBtnText = this.props.intl.formatMessage({
          id: 'aspire.profilePicture.editProfilePicture',
          defaultMessage: 'Edit Profile Picture',
        })
      }
    }
    let clickToChangeBtn = (
      <button
        tabIndex={0}
        aria-label={
          isPictureUploaded
            ? editModalAriaLabel(intl)['profile_picture']['edit']
            : editModalAriaLabel(intl)['profile_picture']['upload']
        }
        className="btn btn-primary btn-click-to-change-picture"
        onClick={(e) => this.handleClickEdit(e)}>
        {uploadBtnText}
      </button>
    )
    if (uploading) {
      clickToChangeBtn = (
        <a
          href="javascript:void(0);"
          className="btn btn-primary btn-click-to-change-picture cusrsor-not-allowed"
          type="button"
          disabled>
          {this.props.intl.formatMessage({
            id: 'aspire.profilePicture.uploading',
            defaultMessage: 'Uploading. Please wait...',
          })}
        </a>
      )
    }

    let editPictureBtn = (
      <a
        href="javascript:void(0);"
        className="btn btn-primary btn-click-to-change-picture"
        type="button"
        onClick={this.openEditModal}>
        {uploadBtnText}
      </a>
    )

    let modalElement = document.getElementsByClassName(
      'profile-picture-edit-modal'
    )
    if (modalElement.length > 0) {
      setTimeout(() => {
        modalElement[0].style.paddingLeft = '0px'
      }, 10)
    }

    return (
      <div className="as-edit-wrapper as-profile-edit-wrapper">
        <div className="as-edit-close-div">
          <a
            tabIndex={0}
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={() =>
              hideEditModal(
                'profile_picture',
                currentIndex,
                sectionWiseTextEditable,
                sectionWiseTextStatic,
                this.state.editMade
              )
            }
            className="icon-cross as-profile-edit-close-btn modal-close-button"
          />
        </div>
        <div className="as-edit-heading-wrapper as-profile-edit-heading-wrapper">
          <div className="as-edit-heading as-profile-edit-heading">
            {((initialState === 0 && modalState === 1) ||
              (initialState === 1 && modalState === 0)) && (
              <div
                className="as-profile-edit-back"
                onClick={(e) => {
                  if (modalState === 1) {
                    this.updateState(0)
                  } else {
                    this.updateState(1)
                  }
                }}>
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/icon-circle-arrow-left.svg`}
                  className="as-profile-edit-back-icon"
                  width="17"
                  height="17"
                  alt={this.props.intl.formatMessage({
                    id: 'aspire.profilePicture.previousEdits',
                    defaultMessage: 'Previous edits',
                  })}
                />
              </div>
            )}
            {modalState === 0
              ? this.props.intl.formatMessage({
                  id: 'aspire.profilePicture.heading',
                  defaultMessage: 'Profile Picture',
                })
              : this.props.intl.formatMessage({
                  id: 'aspire.profilePicture.editHeading',
                  defaultMessage: 'Edit profile picture',
                })}
          </div>
          {modalState === 1 && (
            <div
              className="as-profile-edit-previous"
              onClick={() => showLogModal('Profile Picture')}>
              <div className="as-profile-edit-log">
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/icon-blue-reload.svg`}
                  className="as-profile-edit-log-img"
                  width="24"
                  height="24"
                  alt={this.props.intl.formatMessage({
                    id: 'aspire.profilePicture.previousEdits',
                    defaultMessage: 'Previous edits',
                  })}
                />
              </div>
              {this.props.intl.formatMessage({
                id: 'aspire.profilePicture.previousEdits',
                defaultMessage: 'Previous Edits',
              })}
            </div>
          )}
        </div>
        {modalState === 0 ? (
          <div
            className={`row as-eq-height-row as-profile-eq scroll-hidden ${
              initialState === 1 && modalState === 0
                ? 'as-profile-eq-height'
                : 'as-profile-eq-height-footer'
            }`}>
            <div className="as-profile-edit-container-eq-left as-profile-picture-container col-sm-6">
              <SamplesGuide
                tabIndex={0}
                fetchId={fetchId}
                currentSection="Profile Picture"
              />
            </div>
            <div className="as-profile-edit-container-eq-right as-profile-picture-container col-sm-6">
              <div className="as-edit-heading-picture">
                <span
                  tabIndex={0}
                  aria-label={
                    editModalAriaLabel(intl)['profile_picture']['profile_pic']
                  }>
                  {this.props.intl.formatMessage({
                    id: 'aspire.profilePicture.yourProfilePic',
                    defaultMessage: 'Your Profile Picture',
                  })}
                </span>
              </div>
              <div className="as-picture-sample-wrapper">
                <div className="as-picture-sample-img-container">
                  <div className="as-picture-bg-color" />
                  <div className="as-edit-img">
                    <img
                      src={imageUrl}
                      className="edit-img-circular"
                      width="200"
                      height="200"
                      alt={this.props.intl.formatMessage({
                        id: 'aspire.profilePicture.yourProfilePic',
                        defaultMessage: 'Your profile picture',
                      })}
                    />
                  </div>
                </div>
                <div className="as-picture-sample-feedback-container">
                  {!isPictureUploaded ? pictureNotUploaded : output['detected']}
                  {this.notDetectedAnything ? (
                    <div className="text-red red-info-msg-detect as-picture-feedback-tile">
                      {this.props.intl.formatMessage({
                        id: 'aspire.profilePicture.unableToDetectFeatures',
                        defaultMessage: ' * Unable to detect other features.',
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.renderImageEditor(isPictureUploaded, initialFeedback)}
        {initialState === 0 && modalState === 0 && (
          <div className="as-profile-edit-footer">
            {_.isEmpty(this.dataURI) ? (
              <div className="btn-click-to-change-picture-block">
                <form method="post" ref={(c) => (this.form = c)}>
                  {clickToChangeBtn}
                  <input
                    aria-label={this.props.intl.formatMessage({
                      id: 'aspire.profilePicture.inputFileAriaLabel',
                      defaultMessage: 'Upload your profile picture file',
                    })}
                    type="file"
                    name="profile_picture"
                    accept="image/*"
                    className="visually-hidden hide-it"
                    ref={(c) => (this.formPhoto = c)}
                    onChange={this.handleFile}
                  />
                </form>
              </div>
            ) : (
              <div className="btn-click-to-change-picture-block">
                {editPictureBtn}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    imageData: state.imageData,
    processingStatus: state.aspireFeedbackData.status,
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      ownProps.uploadingEditedData,
    hideSmileAndFBRatio: fetchCustomisation(
      state.AspireCommunityCustomization.data,
      'hide_smile_&_face_to_body_feedback'
    ),
    user: state.user.data,
    initialState: state.editData.initiaProfilPicEditState,
  }
}
export default connect(mapStateToProps, {
  uploadImage,
  updateImageData,
  changeProfilePicInitialEditState,
  saveCurrentImage,
  resetImageDataUrl,
})(injectIntl(ProfilePicture))
